/* CRO 24 Sep 2026 v2: the talking video with one big button. See snippets/explainer-video.liquid.
   Desktop: plays muted while on screen, one click restarts it with sound.
   Phone: nothing plays until the tap, then it plays with sound.
   25 Sep (James): on a phone, once the viewer has started it with sound it keeps playing when they scroll away, in a
   small player in the corner (tap it to go back to the video, x to stop). A "Watch the video" button on the main
   photo takes them straight to it. Swiping to another photo still stops it, as the gallery always has. */
(function () {
  if (window.__impExplainerVideo) return;
  window.__impExplainerVideo = true;

  var desktop = window.matchMedia('(min-width: 769px)');

  function playWithSound(box) {
    var v = box && box.querySelector('video');
    if (!v) return;
    v.muted = false;
    v.loop = false;
    try { v.currentTime = 0; } catch (e) {}
    v.controls = true;
    box.classList.remove('is-muted-playing');
    box.classList.add('is-playing');
    var p = v.play();
    if (p && p.catch) {
      p.catch(function () {
        v.muted = true;
        v.play();
      });
    }
  }

  // The corner player is fixed to the screen but still painted inside the photo column, which the page draws under the
  // product details. While it floats, the positioned parts of that column (inside this section) are lifted to layer 2:
  // over the details, still under the header (400), the sticky add to basket bar and the basket.
  function lift(box, on) {
    var el = box.parentElement;
    while (el && el !== document.body) {
      if (on && el.__xvZ === undefined && getComputedStyle(el).position !== 'static') {
        el.__xvZ = el.style.zIndex;
        el.style.zIndex = '2';
      } else if (!on && el.__xvZ !== undefined) {
        el.style.zIndex = el.__xvZ;
        el.__xvZ = undefined;
      }
      if (el.classList.contains('shopify-section')) break;
      el = el.parentElement;
    }
  }

  function float(box) {
    var v = box.querySelector('video');
    if (!v || box.classList.contains('is-floating')) return;
    // Keep clear of the sticky add to basket bar whenever the page has one (it slides in and out as you scroll).
    var atc = document.querySelector('sticky-atc');
    var h = atc ? atc.getBoundingClientRect().height || atc.offsetHeight || 0 : 0;
    box.style.setProperty('--xv-float-bottom', Math.round(h + 12) + 'px');
    v.controls = false;
    lift(box, true);
    box.classList.add('is-floating');
  }

  function unfloat(box) {
    if (!box.classList.contains('is-floating')) return;
    box.classList.remove('is-floating');
    lift(box, false);
    var v = box.querySelector('video');
    if (v && box.classList.contains('is-playing')) v.controls = true;
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    var btn = t.closest('.xv__btn');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      playWithSound(btn.closest('.xv'));
      return;
    }
    var close = t.closest('.xv__close');
    if (close) {
      e.preventDefault();
      e.stopPropagation();
      var cb = close.closest('.xv');
      cb.querySelector('video').pause();
      unfloat(cb);
      return;
    }
    var frame = t.closest('.xv.is-floating .xv__frame');
    if (frame) {
      e.preventDefault();
      e.stopPropagation();
      var fb = frame.closest('.xv');
      unfloat(fb);
      fb.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, true);

  // Phone product page: a button on the main photo that goes to the video and plays it with sound.
  function addJump(box) {
    var slide = box.closest('.pdp-xv-slide');
    var carousel = slide && slide.closest('carousel-slider');
    var first = carousel && carousel.querySelector('.slider__item');
    if (!first || first === slide || first.querySelector('.xv-jump')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'xv-jump';
    b.innerHTML = '<span class="xv-jump__icon" aria-hidden="true"><svg viewBox="0 0 24 24" width="14" height="14" focusable="false"><path d="M8 5v14l11-7z" fill="currentColor"/></svg></span><span>Watch the video</span>';
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      playWithSound(box);
      if (typeof carousel.scrollToElement === 'function') {
        carousel.scrollToElement(slide);
      } else {
        slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    });
    // On the photo itself: the slide runs on below the photo, so its bottom edge is hidden.
    var host = first.querySelector('.product-media') || first;
    host.classList.add('xv-jump-host');
    host.appendChild(b);
  }

  function watch(box) {
    var v = box.querySelector('video');
    if (!v || box.__xvWatched) return;
    box.__xvWatched = true;
    // The theme's gallery plays a video when its slide comes into view, muted: show the sound button then.
    v.addEventListener('play', function () {
      if (v.muted && !box.classList.contains('is-playing')) box.classList.add('is-muted-playing');
    });
    v.addEventListener('pause', function () {
      box.classList.remove('is-muted-playing');
      unfloat(box);
    });
    v.addEventListener('ended', function () { unfloat(box); });
    addJump(box);
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var seen = en.isIntersecting && en.intersectionRatio >= 0.3;
        if (seen) {
          unfloat(box);
          if (!box.classList.contains('is-playing') && desktop.matches && box.offsetParent !== null) {
            v.muted = true;
            v.loop = true;
            var p = v.play();
            if (p && p.then) {
              p.then(function () { box.classList.add('is-muted-playing'); }).catch(function () {});
            }
          }
          return;
        }
        if (box.classList.contains('is-playing') && !desktop.matches) {
          // Playing with sound on a phone: keep it going. Once it has scrolled right off the screen (not just
          // swiped sideways in the gallery), show it in the corner.
          var r = en.boundingClientRect;
          var vh = window.innerHeight || document.documentElement.clientHeight;
          if (!en.isIntersecting && (r.bottom <= 0 || r.top >= vh) && !v.paused && !v.ended) float(box);
          return;
        }
        if (!v.paused) {
          v.pause();
          box.classList.remove('is-muted-playing');
        }
      });
    }, { threshold: [0, 0.3] }).observe(box);
  }

  function init() {
    var boxes = document.querySelectorAll('.xv');
    for (var i = 0; i < boxes.length; i++) watch(boxes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
